export default __webpack_public_path__ + "static/media/2.0d6e8ce1.jpg";